import { APICore } from "./apiCore";

const api = new APICore();

// category
function addVideo(params: {
  name: string;
  day: string;
  video: File;
  subCourseId: string;
}) {
  const baseUrl = "/video";
  return api.createWithFile(`${baseUrl}`, params);
}

function getVideo() {
  const baseUrl = "/video";
  return api.get(`${baseUrl}`, {});
}

function updateVideo(
  id: number,
  params: { name: string; day: string; video: File; subCourseId: string }
) {
  const baseUrl = `/video/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteVideo(id: number) {
  const baseUrl = `/video/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addVideo, deleteVideo, getVideo, updateVideo };
